// The toggles locked while content is marked as female content. Only the Kedayo Pink may carry it, so its
// flags are deliberately absent. Female content switches these off as well as locking them, so a locked
// toggle never reads as on.
const femaleContentLockedFields = {
    // Podcasts and sub-podcasts: visibility and enabled-by-default on the App, the Naki Bolt and the Kedayo.
    podcast: [
        "isVisibleInApp",
        "isTurnedOnByDefaultInApp",
        "isVisibleInEmbeddedApp",
        "isTurnedOnByDefaultInEmbeddedApp",
        "isVisibleInHandheldApp",
        "isTurnedOnByDefaultInHandheldApp",
    ],
    // Artists carry visibility only; their albums carry the enabled-by-default flags.
    artist: ["isVisibleInApp", "isVisibleInEmbeddedApp", "isVisibleInHandheldApp"],
    // An album follows its artist's female flag, radio default included.
    album: [
        "isTurnedOnByDefault",
        "isTurnedOnByDefaultInApp",
        "isTurnedOnByDefaultInEmbeddedApp",
        "isTurnedOnByDefaultInHandheldApp",
    ],
};

export default femaleContentLockedFields;
